module.exports = __webpack_public_path__ + "static/media/paul_thomas.5e068901.jpeg";